// extracted by mini-css-extract-plugin
export default {"rightofsidenavcontainer":"Content_rightofsidenavcontainer__3ihRb","companyList":"Content_companyList__QUcc1","pagecontainer":"Content_pagecontainer__tIUDi"};